<template>
  <div>
    <div class="section">
      <div class="container section__content">
        <h2 class="std__subtile yellow">{{$t("chinese_zodiac")}}</h2>
        <p class="std__subtile lg">{{ czodiacs[`sign_${language}`] }}</p>
        <ul class="yearList">
          <li v-for="year in czodiacs.years" :key="year.key">
            <span>{{ year }}</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="section">
      <div class="container section__content">
        <div class="row">
          <div class="col-md-8 order-2 order-md-1 m2--topBtm">
            <ul class="nav nav-tabs custom" id="myTab" role="tablist">
              <li class="nav-item">
                <a
                  class="nav-link active"
                  id="personality-tab"
                  data-toggle="tab"
                  href="#personality"
                  role="tab"
                  aria-controls="personality"
                  aria-selected="false"
                  >{{$t("personality")}}</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  id="health-tab"
                  data-toggle="tab"
                  href="#health"
                  role="tab"
                  aria-controls="health"
                  aria-selected="true"
                  >{{$t("health")}}</a
                >
              </li>
              <li class="nav-item">
                <a
                  class="nav-link"
                  id="carrers-tab"
                  data-toggle="tab"
                  href="#carrers"
                  role="tab"
                  aria-controls="carrers"
                  aria-selected="true"
                  >{{$t("careers")}}</a
                >
              </li>
            </ul>
            <div class="tab-content" id="myTabContent">
              <div
                class="tab-pane fade show active"
                id="personality"
                role="tabpanel"
                aria-labelledby="personality-tab"
              >
                <p class="std__txt" >{{ czodiacs.personality[`first_${language}`] }}</p>
                <p class="std__txt" >{{ czodiacs.personality[`second_${language}`] }}</p>
              </div>
              <div
                class="tab-pane fade"
                id="health"
                role="tabpanel"
                aria-labelledby="health-tab"
              >
                <p class="std__txt">{{ czodiacs.health[`${language}`] }}</p>
              </div>
              <div
                class="tab-pane fade"
                id="carrers"
                role="tabpanel"
                aria-labelledby="carrers-tab"
              >
                <p>{{ czodiacs.carrers[`first_${language}`] }}</p>
                <p class="best_career">{{$t("best_career")}}:</p>
                <p>{{ czodiacs.carrers[`second_${language}`] }}</p>
              </div>
            </div>
          </div>
          <div class="col-md-4 order-1 order-md-2 m2--topBtm">
            <div class="imagePlaceholder chinese">
              <span class="symbol">{{ czodiacs.unicode_symbol }}</span>
              <img :src="czodiacs.image" :alt="czodiacs.sign" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="section" id="bottomSection">
      <div class="container section__content">
        <div class="row">
          <div class="col-md-6 m2--topBtm">
            <p class="std__subtile md bdr">{{$t("lucky")}}</p>
            <div class="rowContent">
              <span>{{$t("numbers")}}:</span>
              <div
                class="inlineTags"
                v-for="number in czodiacs.lucky['numbers']"
                :key="number.key"
              >
                <div class="circle_num">{{ number }}</div>
              </div>
            </div>
            <div class="rowContent">
              <span>{{$t("colors")}}:</span>
              <div class="inlineTagsWrap">
                <div
                  class="inlineTags"
                  v-for="color in czodiacs.lucky['code_color_luc']"
                  :key="color.key"
                >
                  <div
                    class="circle"
                    v-bind:style="{ background: color[0] }"
                    :title="color[1]"
                  ></div>
                </div>
              </div>
            </div>
            <div class="rowContent">
              <span>{{$t("directions")}}:</span>
              <span>
                <div class="inlineTags text" v-for="direction in czodiacs.lucky[`directions_${language}`]" :key="direction.key">
                  <div class>{{ direction }}</div>
                </div>
              </span>
            </div>
          </div>
          <div class="col-md-6 m2--topBtm">
            <p class="std__subtile md bdr">{{$t("unlucky")}}</p>
            <div class="rowContent">
              <span>{{$t("numbers")}}:</span>
              <div
                class="inlineTags"
                v-for="number in czodiacs.unlucky['numbers']"
                :key="number.key"
              >
                <div class="circle_num">{{ number }}</div>
              </div>
            </div>
            <div class="rowContent">
              <span>{{$t("colors")}}:</span>
              <div class="inlineTagsWrap">
                <div
                  class="inlineTags"
                  v-for="color in czodiacs.unlucky['code_color_unluc']"
                  :key="color.key"
                  :title="color[1]"
                >
                  <div
                    class="circle"
                    v-bind:style="{ background: color[0] }"
                  ></div>
                  
                </div>
              </div>
            </div>
            <div class="rowContent">
              <span>{{$t("directions")}}:</span>
              <span>
                <div class="inlineTags text" v-for="direction in czodiacs.unlucky[`directions_${language}`]" :key="direction.key" >
                  <div class>{{ direction }}</div>
                </div>
              </span>
            </div>
          </div>
          <div class="col-md-6 m2--topBtm">
            <p class="std__subtile md bdr">{{$t("best_match")}}</p>
            <div class="inlineTags" v-for="best in czodiacs.best" :key="best.key">
              <img class="match_icon" :src="best.image" alt  :title="best[`best_${language}`]"/>
            </div>
          </div>
          <div class="col-md-6 m2--topBtm">
            <p class="std__subtile md bdr">{{$t("worst_match")}}</p>
            <div class="inlineTags" v-for="worst in czodiacs.worst" :key="worst.key">
              <img class="match_icon" :src="worst.image" alt  :title="worst[`worst_${language}`]"/>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import zodiacs from "./zodiac.json";
import colors from "./colors.json";
import { mapGetters,mapActions } from "vuex";

export default {
  data() {
    return {
      czodiacs: {},
      czodiac: zodiacs,
      colors: colors,
    };
  },
  computed: mapGetters(["language"]),
  created() {
    this.getCZodiac();
  },
  mounted(){
    if(this.language=="arabic"){
      document.getElementById("bottomSection").classList.add("arLayout")
    }else{
      document.getElementById("bottomSection").classList.remove("arLayout")
    }
  },
  methods: {
    getCZodiac() {
      const zod = this.czodiac.eastern_zodiac;
      let czod = this.$route.params.chinesesign;
      let sign = [];
      let love_best = {};
      let love_worst = {};
      let col_code_unluc = [];
      let col_code_luc = [];
      for (let [key, value] of Object.entries(zod)) {
        if (value.sign_english.toLowerCase() === czod) {
          for (let i = 0; i < value.love["best_english"].length; i++) {
            //to get best compatibility icon
            love_best[i] = {
              "image": require(`../../assets/mobiscope/imgs/cz_icon/${value.love["best_english"][i]}.svg`),
              "best_english":`${value.love["best_english"][i]}`,
              "best_arabic":`${value.love["best_arabic"][i]}`,
              "best_greek":`${value.love["best_greek"][i]}`,
              "best_malay":`${value.love["best_malay"][i]}`,
              "best_thai":`${value.love["best_thai"][i]}`
            }
          }

          for (let i = 0; i < value.love["worst_english"].length; i++) {
            //to get worst compatibility icon
            love_worst[i] = {
              "image": require(`../../assets/mobiscope/imgs/cz_icon/${value.love["worst_english"][i]}.svg`),
              "worst_english":`${value.love["worst_english"][i]}`,
              "worst_arabic":`${value.love["worst_arabic"][i]}`,
              "worst_greek":`${value.love["worst_greek"][i]}`,
              "worst_malay":`${value.love["worst_malay"][i]}`,
              "worst_thai":`${value.love["worst_thai"][i]}`
            }
          }

          value.best = love_best;
          value.worst = love_worst;
          value.sign = value.sign_english.replace(/^./, value.sign_english[0].toUpperCase());
          value.image = require(`../../assets/mobiscope/imgs/cz_animal/${value.sign}.svg`);

          sign.push(value);
        }
      }

      //get color code for unlucky color
      let len = sign[0].unlucky.colors_english.length;

      for (let i = 0; i < len; i++) {
        let col = this.getColorCode(sign[0].unlucky.colors_english[i]);
        col_code_unluc[i] = [col, sign[0].unlucky.colors_english[i]];
      }

      sign[0].unlucky.code_color_unluc = col_code_unluc;

      //get color code for lucky color
      let len1 = sign[0].lucky.colors_english.length;

      for (let i = 0; i < len1; i++) {
        let col = this.getColorCode(sign[0].lucky.colors_english[i]);
        col_code_luc[i] = [col, sign[0].lucky.colors_english[i]];
      }

      sign[0].lucky.code_color_luc = col_code_luc;

      this.czodiacs = sign[0];
    },
    getColorCode(color) {
      let co = this.colors.colors;

      //console.log(co)
      let found = co.find(function(element) {
        return element.name == color;
      });
      return found.hex;
    }
  }
};
</script>

<style scoped lang="scss">
.yearList {
  display: flex;
  justify-content: space-between;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
  li {
    display: inline-block;
  }
  span {
    font-size: 1.3rem;
  }
}

.circle {
  height: 20px;
  width: 20px;
  border-radius: 50%;
}

.circle_num {
  height: 30px;
  width: 30px;
  border-radius: 50%;
  text-align: center;
  line-height: 30px;
  color: #e90f15;
  background: #fff;
  font-weight: 700;
}
.imagePlaceholder.chinese {
  width: 100%;
  max-width: 320px;
  text-align: center;
}

.arLayout {
  text-align: right;
}

@media (max-width: 991px) {
  .imagePlaceholder.chinese {
    margin: 0 auto;
    max-width: 220px;
  }
  .yearList {
    -webkit-box-pack: end;
    -ms-flex-pack: end;
    justify-content: end;
    li {
      margin: 8px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/mobiscope/ChineseZodiacDetails.vue